import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Layout from '../components/Layout';
import RealTimeMetrics from '../components/RealTimeMetrics';
import SubscriptionTiers from '../components/SubscriptionTiers';
import SystemHealth from '../components/SystemHealth';
import AlertsWarnings from '../components/AlertsWarnings';
import AIModelSummary from '../components/AIModelSummary';
import UserFeedback from '../components/UserFeedback';
import UsersCompanies from '../components/UsersCompanies';
import BillingSubscriptions from '../components/BillingSubscriptions';
import CustomerSupport from '../components/CustomerSupport';
import Infrastructure from '../components/Infrastructure';

const DashboardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  backgroundColor: '#F7FAFC',
}));

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginLeft: 80, // Width of sidebar
}));

const DashboardTitle = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 700,
  color: '#1A202C',
  marginBottom: theme.spacing(3),
}));

const WidgetCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  borderRadius: 12,
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  border: '1px solid #E2E8F0',
}));

const AdminDashboard: React.FC = () => {
  return (
    <DashboardContainer>
      <Layout>
        <MainContent>
        <DashboardTitle>Aletheia Admin Portal</DashboardTitle>
        
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, 
          gap: 3 
        }}>
          {/* Top Row */}
          <WidgetCard>
            <RealTimeMetrics />
          </WidgetCard>
          
          <WidgetCard>
            <SubscriptionTiers />
          </WidgetCard>
          
          <WidgetCard>
            <SystemHealth />
          </WidgetCard>
          
          {/* Middle Row */}
          <WidgetCard>
            <AIModelSummary />
          </WidgetCard>
          
          <WidgetCard>
            <UserFeedback />
          </WidgetCard>
          
          <WidgetCard>
            <AlertsWarnings />
          </WidgetCard>
          
          {/* Bottom Row */}
          <WidgetCard>
            <UsersCompanies />
          </WidgetCard>
          
          <WidgetCard>
            <BillingSubscriptions />
          </WidgetCard>
          
                      <WidgetCard>
              <CustomerSupport />
            </WidgetCard>
            {/* Additional Row for Infrastructure */}
            <WidgetCard>
              <Infrastructure />
            </WidgetCard>
        </Box>
        </MainContent>
      </Layout>
    </DashboardContainer>
  );
};

export default AdminDashboard;
